import Pusher from 'pusher-js';
import CONST from '@/utils/Constants'
import eventBus from '@/config/EventBus';
import ApiHelper from "@/helpers/ApiHelper";
import ErrorHelper from "@/helpers/ErrorHelper";
import oToast from '@/objects/o-toast/o-toast.vue';
import oButton from "@/objects/o-button/o-button.vue"
import oModal from "@/objects/o-modal/o-modal.vue"

export default {
    name: "LayoutGreenScreen",
    components: {
       "o-toast": oToast,
       "o-button": oButton,
       "o-modal": oModal
    },
    data() {
      return {
        pusher: null,
        channel: null,
        idle: false,
        timeToIdle: 10,
        interval: null,
        inited: false
      };
    },
    methods: {
      initializePusher() {
        if(!this.$store.state.pusherGreenScreenInitiated) {
          const _this = this;

          if(!this.pusher) {
            this.pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
              cluster: 'eu'
            });

            if(process.env.VUE_APP_ENV != CONST.VALUE.ENV.PRODUCTION) {
              Pusher.logToConsole = true;
            }

            this.channel = this.pusher.subscribe(CONST.VALUE.PUSHER.CHANNEL);

            this.channel.bind(CONST.EVENT.DRAWING.CREATED, function(data) {
              _this.$store.commit('addDrawing', data.url);
              _this.pushMessage();
            });
          }

          this.$store.commit('pusherGreenScreenInitiated', true);
        }
      },
      pushMessage() {
        let data = {
          'message': this.$store.getters.drawingsCount,
          'channel': CONST.VALUE.PUSHER.CHANNEL,
          'event-name': CONST.EVENT.QUEUE.UPDATED
        }

        ApiHelper.post(CONST.API.ROUTE.MESSAGE.PUSH, data, {headersType: 'basic'})
        .catch(error => {
            ErrorHelper.catch(error, this);
        });
      },
      stop() {
        this.idle = false;
        clearInterval(this.interval);

        this.$store.commit('removeCurrentDrawing');

        if(this.pusher) {
          this.pusher.unsubscribe(CONST.VALUE.PUSHER.CHANNEL); // unsubscribe from channel, so number of concurrent pusher connections stays low
        }

        window.location.href = CONST.ROUTE.INVENT; // reload app, so everything is re-initiated
      },
      proceed() {
        this.idle = false;
        clearInterval(this.interval);
      }
    },
    mounted() {
      const $this = this;

      if(!this.$store.state.invention_app_inited) {
        this.initializePusher();

        eventBus.$on(CONST.EVENT.INVENTION.STOPPED, function () {
          $this.stop();
        });

        this.$store.commit('invention_app_inited', true);
      }
    },
    onIdle() {
      const _this = this;
      this.timeToIdle = 10;

      clearInterval(this.interval);

      if(this.$store.state.drawings) {
        if(this.$store.state.drawings.length > 0) {
          this.idle = true;

          this.interval = setInterval(function(){
            _this.timeToIdle--;

            if(_this.timeToIdle == -1) {
              clearInterval(this.interval);

              _this.stop();
            }
          }, 1000);
        }
      }
    }
};
